import { render, staticRenderFns } from "./Component.vue?vue&type=template&id=6c8bde15&"
import script from "./Component.vue?vue&type=script&lang=js&"
export * from "./Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../NodeModules/Ljbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports